<template>
    <div v-show="show" class="dialog-container">
        <div class="dialogContent">
            <div class="title">{{title}}</div>
            <img @click="close" class="close" src="./assets/close.png" alt="">
            <div class="content">
                <textarea :placeholder="placeholder" v-model="content" :maxlength="maxLength" :disabled="!canEdit"></textarea>
                <p v-if="canEdit">{{num}}/{{maxLength}}</p>
            </div>
            <div class="btns">
                <p v-if="canEdit && !singleBtn" @click="confirm" class="btn g">确定</p>
                <p v-if="canEdit && singleBtn" @click="confirm" class="btn g">确定</p>
                <p v-if="!canEdit" @click="cancel" class="btn g">返回</p>
                <p v-if="canEdit && !singleBtn" @click="cancel" class="btn">取消</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    watch: {
        content(to) {
            this.num = to.length;
        }
    },
    data() {
        return {
            placeholder: '',
            show: false,
            config: {},
            callback: null,
            title: '退回理由',
            canEdit: true,
            maxLength: 100,
            num: 0,
            content: '',
            singleBtn: false,
            errTitle: '退回理由不能为空'
        }
    },
    methods: {
        open(config, callback) {
            this.config = config;
            this.callback = callback;
            if(config.title != undefined){
                this.title = config.title;
            }
            if(config.canEdit != undefined){
                this.canEdit = config.canEdit;
            }
            if(config.maxLength != undefined){
                this.maxLength = config.maxLength;
            }
            if(config.content != undefined){
                this.content = config.content;
            }
            if(config.singleBtn != undefined){
                this.singleBtn = config.singleBtn;
            }
            if(config.placeholder != undefined){
                this.placeholder = config.placeholder;
            }
            if(config.errTitle != undefined){
                this.errTitle = config.errTitle;
            }
            this.show = true;
        },
        confirm() {
            if(this.errTitle == '无需输入'){
                this.show = false;
                if(this.content){
                    this.callback(this.content)
                }else{
                    this.callback('null')
                }
            }else{
                if(this.content){
                    this.show = false;
                    this.callback(this.content)
                }else{
                    this.$toast(this.errTitle)
                }
            }
        },
        cancel() {
            this.show = false;
            this.callback(false)
        },
        async close() {
            if(this.config.double){
                const c = await this.$confirm('确认取消退回操作？')
                if (!c) return
                this.cancel()
            }else{
                this.cancel()
            }
            
        }
    }
}
</script>

<style lang="less">
    .dialog-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1001;
        background-color: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);

        .dialogContent {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 498px;
            height: 394px;
            display: flex;
            flex-direction: column;
            margin-left: -249px;
            margin-top: -197px;
            background: #F9F9F9;
            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
            border-radius: 4px;
            padding: 20px 30px 24px;
            box-sizing: border-box;

            .title {
                font-size: 24px;
                line-height: 33px;
                color: #050F0F;
                margin-bottom: 20px;
            }

            .close {
                position: absolute;
                top: 20px;
                right: 30px;
                width: 21px;
                height: 21px;
                user-select: none;
                cursor: pointer;
            }

            .content {
                position: relative;
                width: 438px;
                height: 240px;
                background-color: rgba(185, 195, 195, 0.2);
                border-radius: 4px;
                padding: 14px 20px;
                box-sizing: border-box;

                textarea {
                    width: 100%;
                    height: 100%;
                    resize: none;
                    background-color: transparent;
                    font-size: 16px;
                    line-height: 30px;
                    color: #050F0F;
                    // font-weight: bold;

                    &::-webkit-scrollbar {
                        width: 0px;
                    }
                    &::-webkit-scrollbar-thumb {
                        background: #ddd;
                        border-radius: 0px;
                    }

                    &::placeholder {
                        font-size: 14px;
                        color: #B9C3C3;
                        font-weight: normal;
                    }
                }

                p {
                    position: absolute;
                    right: 14px;
                    bottom: 6px;
                    font-size: 12px;
                    line-height: 17px;
                    color: #829191;
                }
            }

            .btns {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin: 24px auto 0;

                .btn {
                    width: 120px;
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    background: #B9C3C3;
                    border-radius: 4px;
                    color: #FFF;
                    user-select: none;
                    cursor: pointer;

                    &:nth-of-type(2) {
                        margin-left: 20px;
                    }

                    &.g {
                        background: #41B48C;
                    }
                }
            }
        }
    }
</style>